import {
  isDemoPage,
  isECCompletePage,
  isECFormPage,
  isECInProgressPage,
  isECSuccessPage,
  isECUpgradePage,
  isExpertCheckPage,
  isGrammarPage,
  isPlagiarismPage,
  isPlansPage,
  isRootPage,
  isTCPage,
} from '@src/utils/routes'
import { createSelector } from 'reselect'
import { getLoggedIn, getPaidMember } from '../auth/selectors'
import { BIBME, CHEGG, CITATION_MACHINE, EASYBIB } from '../site/types'
import { RootState } from '../types'
import { LOGGED_IN, LOGGED_OUT, NON_MEMBER, PAGE_TYPES, PAID_MEMBER } from './constants'
import {
  BIBME_PRODUCT,
  CHEGG_PRODUCT,
  CITATION_MACHINE_PRODUCT,
  EASYBIB_PRODUCT,
  PageType,
  ProductMap,
} from './types'

export const getPageNameFromPath = (pathname: string): PageType => {
  if (isDemoPage(pathname)) {
    switch (true) {
      case isExpertCheckPage(pathname):
        return PAGE_TYPES.EC_DEMO
      case isPlagiarismPage(pathname):
        return PAGE_TYPES.EDITOR_PLAGIARISM_DEMO
      // demo grammar page url is "/demo"
      default:
        return PAGE_TYPES.EDITOR_GRAMMAR_DEMO
    }
  }
  switch (true) {
    case isRootPage(pathname):
      return PAGE_TYPES.PAPERS
    case isECSuccessPage(pathname):
      return PAGE_TYPES.EC_SUCCESS
    case isECInProgressPage(pathname):
      return PAGE_TYPES.EC_IN_PROGRESS
    case isECCompletePage(pathname):
      return PAGE_TYPES.EC_COMPLETE
    case isECUpgradePage(pathname):
      return PAGE_TYPES.EC_UPGRADE
    case isECFormPage(pathname):
      return PAGE_TYPES.EC_FORM
    case isPlagiarismPage(pathname):
      return PAGE_TYPES.EDITOR_PLAGIARISM
    case isGrammarPage(pathname):
      return PAGE_TYPES.EDITOR_GRAMMAR
    case isTCPage(pathname):
      return PAGE_TYPES.TERMS_AND_CONDITIONS
    case isPlansPage(pathname):
      return PAGE_TYPES.PLANS
    default:
      return PAGE_TYPES.PAPER_NOT_FOUND
  }
}

export const getAuthState = (state: RootState) =>
  getLoggedIn(state) ? LOGGED_IN : LOGGED_OUT

export const getSubscriptionStatus = createSelector([getPaidMember], paidMember =>
  paidMember ? PAID_MEMBER : NON_MEMBER
)

export const getFileExtension = (filename: string): string => {
  const extRegex = /(?:\.([^.]+))?$/
  const fileExtension = extRegex.exec(filename)
  if (fileExtension && fileExtension[1]) {
    return fileExtension[1]
  }
  return ''
}

export const getCharacterCount = (text: string): number => text.length

export const productMap: ProductMap = {
  [CHEGG]: CHEGG_PRODUCT,
  [BIBME]: BIBME_PRODUCT,
  [CITATION_MACHINE]: CITATION_MACHINE_PRODUCT,
  [EASYBIB]: EASYBIB_PRODUCT,
}



// WEBPACK FOOTER //
// ./src/state/analytics/helpers.ts